import qs from 'qs';
import apiClient from 'lib/apiClient';

export const updateSubscription = (id, data) =>
  apiClient.post('/API/1_0/subscription.php', { id, ...data });

export const getSubscription = (id) =>
  apiClient
    .get('/API/1_0/subscription.php', { params: { id } })
    .then((s) => s[0]);

export const getSubscriptionItem = (id) =>
  apiClient
    .get('/API/1_0/subscriptionItem.php', { params: { id } })
    .then((s) => s[0]);

export const updateSubscriptionItem = (id, data) =>
  apiClient.post('/API/1_0/subscriptionItem.php', { id, ...data });

async function previewSubscriptionChange(
  customer,
  subscription,
  subscriotionId,
  newPlan,
  prorate = true,
) {
  const date = Math.floor(Date.now() / 1000);
  const options = {
    customer,
    subscription,
    upcoming: 1,
    subscription_prorate: prorate,
    subscription_items: [{ id: subscriotionId, plan: newPlan }],
    subscription_proration_date: date,
  };
  const upcoming = await apiClient
    .get(
      '/API/1_0/invoice.php?' +
        qs.stringify(options, { arrayFormat: 'indices' }),
    )
    .then((s) => s[0]);
  let cost = 0;
  upcoming.lines.data.forEach((i) => {
    if (i.period.start === date) {
      cost = cost + i.amount;
    }
  });
  return cost;
}

export const previewUpgrade = async (
  customer,
  subscriptionId,
  subscriptionItemId,
  plan,
) => {
  let discountPercent = 0;
  let discountAmount = 0;
  const subscription = await getSubscription(subscriptionId);
  if (subscription.discount) {
    discountPercent = subscription.discount.coupon.percent_off || 0;
    discountAmount = subscription.discount.coupon.amount_off || 0;
  }
  const immediateCost = await previewSubscriptionChange(
    customer,
    subscriptionId,
    subscriptionItemId,
    plan,
  );
  return {
    immediateCost: immediateCost,
    discountPercent,
    discountAmount,
  };
};

export const changePlan = async (
  stripeId,
  subscriptionId,
  subscriptionItemId,
  newPlan,
  isUpgrade,
) => {
  const subscription = await getSubscription(subscriptionId);
  if (subscription.discount && isUpgrade) {
    await updateSubscription(subscriptionId, { coupon: '15OFF' });
  }
  await updateSubscriptionItem(subscriptionItemId, {
    plan: newPlan,
    prorate: true,
  });
  await apiClient.post('/API/1_0/invoice.php', { customer: stripeId });
};
